import { RootState } from "shared/redux/store";
import { CookiePreferencesState } from "./cookiePreferencesState";

export const selectCookiePreference = (
  state: RootState,
): CookiePreferencesState => state.cookiePreference;
